module.exports = __webpack_public_path__ + "img/team-map-10.538b6322.png";